<template>
  <v-select
    class="tema-eixo-combo"
    id="temas-select"
    v-model="filter.regionais"
    :items="regionais"
    label="Agência Regional"
    placeholder="Agência Regional"
    multiple
    @change="$emit('onChange')"
    :clearable="true"
    :return-object="true"
  >
    <template slot="no-data"> Nenhuma Agência Regional </template>
  </v-select>
</template>

<script>
export default {
  name: "AppRegionalCombobox",
  props: {
    filter: Object,
    regionais: Array,
  },
};
</script>
